import { render, staticRenderFns } from "./SmartCollectionZone.vue?vue&type=template&id=597d111a&"
import script from "./SmartCollectionZone.vue?vue&type=script&lang=js&"
export * from "./SmartCollectionZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports